/**
 * @file TaskInboxes.jsx
 * @location src/components/layout/notificationbell/TaskInboxes.jsx
 * @role NotificationBell 업무 관련 inbox 섹션 — 안 읽음 / 중지알림 / 팀원-안 읽음정체 (검수대기·@멘션 razor ㉓ 폐기)
 */
import { useMembers } from '../../../store/useMembers';
import { formatDueLabel } from '../../../utils/dateUtils';
import { Icon } from '../../ui/Icon';
import { reminderText } from '../../../utils/reminders';

/** 정체(stall) 배지 — 임계 초과 시에만 렌더. 2배 초과(severe) 면 🔥 강조. */
export function StallBadge({ stall }) {
  if (!stall?.stalled) return null;
  return (
    <span className={`nbell-stall${stall.severe ? ' severe' : ''}`}>
      {stall.severe ? '🔥' : '⏰'} {stall.days}일 정체
    </span>
  );
}

export const STAGE_LABEL = {
  unack: '안 읽음',
};

/**
 * @param {object} props
 * @param {import('../../../data/types.js').Task[]} props.unack
 * @param {import('../../../data/types.js').Task[]} props.subordinateStalls
 * @param {import('../../../data/types.js').Task[]} props.cancelledToMe
 * @param {() => void} props.onGoToTasks
 * @param {(id: string) => void} props.onOpenReview
 * @param {() => void} props.onCloseBell
 */
export function TaskInboxes({
  unack, subordinateStalls, cancelledToMe, upcomingDue = [],
  onGoToTasks, onOpenReview, onCloseBell: _onCloseBell,
}) {
  const { mname } = useMembers();

  return (
    <>
      {cancelledToMe?.length > 0 && (
        <div className="nbell-sec">
          <div className="nbell-sec-title nbell-sec-alert"><Icon name="x" size={14} /> 중지된 업무 <span className="nbell-sec-cnt">{cancelledToMe.length}</span></div>
          {cancelledToMe.map(t => (
            <button key={t.id} className="nbell-item" onClick={() => onOpenReview(t.id)}>
              <div className="nbell-item-title">{t.title}</div>
              <div className="nbell-item-sub">지시: {mname(t.aor)}{t.cancelReason ? ` · 사유: ${t.cancelReason}` : ''}</div>
            </button>
          ))}
        </div>
      )}

      {subordinateStalls.length > 0 && (
        <div className="nbell-sec">
          <div className="nbell-sec-title nbell-sec-alert"><Icon name="urgent" size={14} /> 팀원 정체 <span className="nbell-sec-cnt">{subordinateStalls.length}</span></div>
          {subordinateStalls.map(t => (
            <button key={t.id} className="nbell-item" onClick={onGoToTasks}>
              <div className="nbell-item-title">{t.title} <StallBadge stall={t._stall} /></div>
              <div className="nbell-item-sub">담당: {mname(t.aee)} · {STAGE_LABEL[t._stage] ?? t._stage} · 기한 {formatDueLabel(t.due)}</div>
            </button>
          ))}
        </div>
      )}

      {unack.length > 0 && (
        <div className="nbell-sec">
          <div className="nbell-sec-title"><Icon name="inbox" size={14} /> 안 읽음 <span className="nbell-sec-cnt">{unack.length}</span></div>
          {unack.map(t => (
            <button key={t.id} className="nbell-item" onClick={onGoToTasks}>
              <div className="nbell-item-title">{t.title} <StallBadge stall={t._stall} /></div>
              <div className="nbell-item-sub">지시: {mname(t.aor)} · 기한 {formatDueLabel(t.due)}</div>
            </button>
          ))}
        </div>
      )}

      {upcomingDue.length > 0 && (
        <div className="nbell-sec nbell-sec--rem">
          <div className="nbell-sec-title"><Icon name="bell" size={14} /> 리마인더 <span className="nbell-sec-cnt">{upcomingDue.length}</span></div>
          {upcomingDue.map(t => (
            <button key={t.id} className="nbell-item" onClick={onGoToTasks}>
              <div className="nbell-item-title">
                {t.title} <span className={`nbell-due nbell-due--${t._tier}`}>{reminderText(t)}</span>
              </div>
              <div className="nbell-item-sub">지시: {mname(t.aor)} · 기한 {formatDueLabel(t.due)}</div>
            </button>
          ))}
        </div>
      )}
    </>
  );
}
